const IMAGE_BASE_URL = "https://image.tmdb.org/t/p";

export function getImageUrl(path, size = "w780") {
  if (!path) {
    return "";
  }

  return `${IMAGE_BASE_URL}/${size}${path}`;
}

export function getBackdropUrl(path, size = "original") {
  return getImageUrl(path, size);
}

export function getPosterUrl(path, size = "w500") {
  return getImageUrl(path, size);
}

export function getReleaseYear(date) {
  if (!date) {
    return "Sem data";
  }

  const parsedDate = new Date(date);

  if (Number.isNaN(parsedDate.getTime())) {
    return "Sem data";
  }

  return parsedDate.getFullYear();
}

export function formatFullDate(date) {
  if (!date) {
    return "Data indisponivel";
  }

  const parsedDate = new Date(date);

  if (Number.isNaN(parsedDate.getTime())) {
    return "Data indisponivel";
  }

  return parsedDate.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function formatRuntime(runtime) {
  if (!runtime || runtime <= 0) {
    return "Duracao nao informada";
  }

  const hours = Math.floor(runtime / 60);
  const minutes = runtime % 60;

  if (!hours) {
    return `${minutes}min`;
  }

  return `${hours}h ${minutes.toString().padStart(2, "0")}min`;
}

export function formatVoteAverage(voteAverage) {
  if (!voteAverage && voteAverage !== 0) {
    return "--";
  }

  return Number(voteAverage).toFixed(1);
}

export function getTrailerUrl(trailer) {
  if (!trailer?.key) {
    return "";
  }

  return `https://www.youtube.com/watch?v=${trailer.key}`;
}

export function buildGenreNames(movie) {
  if (Array.isArray(movie?.genres) && movie.genres.length) {
    return movie.genres.map((genre) => genre.name);
  }

  return movie?.genreNames || [];
}
